import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Paper,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Tab,
  Tabs
} from '@material-ui/core';

import SalesOrdersTable from 'components/SalesOrders/SalesOrdersTable';
import CustomerDueDate from 'components/SalesOrders/CustomerDueDate';
import AddProducts from 'components/SalesOrders/AddProducts';
import SOPaymentModal from 'components/SalesOrders/SOPaymentModal';

import {
  setNewSODisplayId, setNewSOCustomerId, setNewSODate, setNewSOActiveStep, clearNewSO,
  addSalesOrder
} from 'redux/actions';
import { standard } from 'constants/userAccountTypes';
import { VAT_UAE } from 'constants/globalVAT';

const mapStateToProps = (state) => ({
  newSalesOrder: state.newSalesOrder
});

const SOListResults = (props) => {

  const {displayId, customerId, soProducts, startDate, endDate, activeStep} = props.newSalesOrder;

  const [open, setOpen] = useState(false);
  const [userTabValue, setUserTabValue] = useState(0);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);

  const saveSalesOrder = () => {
    
    const subTotal = soProducts.reduce((prev, curr) => prev + curr.sellPrice, 0);
    const grandTotal = subTotal + Math.round( subTotal * VAT_UAE );

    const newSalesOrder = {
      displayId,
      customerId,
      startDate,
      endDate,
      total: grandTotal,
      products: soProducts.map(product => ({
        displayId: product.displayId,
        productId: product.productId,
        sellPrice: product.sellPrice,
        ...( product.measurements && {measurements: product.measurements} )
      }))
    };
    props.addSalesOrder(newSalesOrder, props.activeUserId, props.user.adminId);
    
    setOpenPaymentModal(true);
  };
  
  const createSoDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.salesOrder;
    let salesNum;
    length < 100 ? 
      salesNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : salesNum = length
    props.setNewSODisplayId("SO-" + salesNum);
  };

  const addSalesOrder = () => {
    setOpen(true);
    createSoDisplayId();
  };

  const handleNext = () => {
    props.setNewSOActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    props.setNewSOActiveStep(activeStep - 1);
  };

  const handleUserTabChange = (event, newValue) => {
    setUserTabValue(newValue);
  };

  const salesOrderCleanup = () => {
    setOpen(false);
    props.clearNewSO();
    setOpenPaymentModal(false);
  };

  return (
    <Box>
      { open ?
        <Paper>
          <Stepper activeStep={activeStep} orientation="vertical">
            <Step key={"Customer Details and Due Date"}>
              <StepLabel> {"Customer Details and Due Date"} </StepLabel>
              <StepContent>
                <CustomerDueDate
                  customers={props.customers}
                  idGen={props.idGen}
                  user={props.user}
                  customerId={customerId}
                  startDate={startDate}
                  endDate={endDate}
                  setNewSOCustomerId={props.setNewSOCustomerId}
                  setNewSODate={props.setNewSODate}
                />
              </StepContent>
            </Step>
            <Step key={"Set Products"}>
              <StepLabel> {"Set Products"} </StepLabel>
              <StepContent>
                <AddProducts
                  soDisplayId={displayId}
                  soProducts={soProducts}
                  elements={props.products}
                />
              </StepContent>
            </Step>
          </Stepper>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              paddingLeft: 16,
              paddingTop: 4,
              paddingBottom: 16
            }}
          >
            <Button
              color="secondary"
              onClick={salesOrderCleanup}
            >
              Cancel
            </Button>
            { activeStep === 0 ?
            <Button
              style={{ marginLeft: '8px' }}
              disabled={( customerId === 0 || !startDate || !endDate )}
              variant="contained"
              color="primary"
              onClick={handleNext}
            >
              Next
            </Button> :
            <Box>
              <Button onClick={handleBack}>
                Back
              </Button>
              <Button
                style={{ marginLeft: '8px' }}
                disabled={( !soProducts[0] )}
                variant="contained"
                color="primary"
                onClick={saveSalesOrder}
              >
                Finish
              </Button>
            </Box> }
          </Box>
        </Paper> :
        ( props.activeUserType === standard ?
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={addSalesOrder}
              >
                Add Sales Order
              </Button>
            </Box>
            <Box marginTop={2}>
              <SalesOrdersTable
                activeUserType={props.activeUserType}
                salesOrders={props.salesOrders}
                customers={props.customers}
                products={props.products}
                user={props.user}
                setOpenPaymentModal={setOpenPaymentModal}
              />
            </Box>
          </Box> :
          <Box>
            <Box sx={{ display: 'flex' }}>
              <Paper>
                <Tabs
                  value={userTabValue}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleUserTabChange}
                  centered
                >
                  {props.user.standardUsers ? props.user.standardUsers.map((user) => (<Tab key={user.id} label={user.name} />)) : null}
                </Tabs>
              </Paper>
            </Box>
            <Box marginTop={1}>
              <SalesOrdersTable
                userTabValue={userTabValue}
                activeUserType={props.activeUserType}
                salesOrders={props.salesOrders}
                customers={props.customers}
                products={props.products}
                user={props.user}
                setOpenPaymentModal={setOpenPaymentModal}
              />
            </Box>
          </Box>
        )
      }
      { openPaymentModal ?
      <SOPaymentModal
        open={openPaymentModal}
        user={props.user}
        salesOrders={props.salesOrders}
        customers={props.customers}
        newSalesOrder={props.newSalesOrder}
        closeModal={salesOrderCleanup}
      /> : null }
    </Box>
  )
};

export default connect (mapStateToProps, {
  setNewSODisplayId,
  setNewSOCustomerId,
  setNewSODate,
  setNewSOActiveStep,
  clearNewSO,
  addSalesOrder
}) (SOListResults);